/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key)))
Vue.component('validation-errors', () => import('./components/ValidationErrors'));
Vue.component('loading-button', () => import('./components/LoadingButton'));
Vue.component('role-property', () => import('./components/RoleProperty'));
Vue.component('payment-user', () => import('./components/PaymentUser'));
Vue.component('rut-input', () => import('./components/RutInput'));

Vue.component('example-component', () => import('./components/ExampleComponent.vue'));

// Vue.component('index-section', () => import('./components/index/index-section.vue'));
// Vue.component('index-icon', () => import('./components/index/index-icon.vue'));
// Vue.component('index-request', () => import('./components/index/index-request.vue'));
Vue.component('material-transition-group', () => import('./components/animations/MaterialCollectionComponent.vue'));
Vue.component('index-request-section', () => import('./components/index/IndexRequestSection.vue'));
Vue.component('index-request-icon', () => import('./components/index/IndexRequestIcon.vue'));
Vue.component('index-request-link', () => import('./components/index/IndexRequestLink.vue'));
// Question
Vue.component('question-main', () => import('./components/question/main'));
Vue.component('question-register', () => import('./components/question/register'));
Vue.component('question-list', () => import('./components/question/list'));
Vue.component('category-question', () => import('./components/question/category-question'));
Vue.component('question-data', () => import('./components/question/question'));

// Penalty fee - Multas
Vue.component('penalty-fee-register', () => import('./components/penalty_fee/register'));
Vue.component('penalty-fee-select-qualification', () => import('./components/penalty_fee/select_qualification'));
Vue.component('penalty-fee-select-informer', () => import('./components/penalty_fee/select_informer'));
Vue.component('penalty-fee-select-cause', () => import('./components/penalty_fee/select_cause'));

Vue.component('penalty-fee-search', () => import('./components/penalty_fee/search'));
// Vue.component('penalty-fee-search2', () => import('./components/penalty_fee/search2'));
Vue.component('penalty-fee-list', () => import('./components/penalty_fee/list'));
Vue.component('penalty-fee-element', () => import('./components/penalty_fee/element'));
Vue.component('penalty-fee-info', () => import('./components/penalty_fee/info'));

Vue.component('penalty-fee-search-table-daf', () => import('./components/penalty_fee/search_table'));
Vue.component('penalty-fee-search-table-jpl', () => import('./components/penalty_fee/search_table_jpl'));


// Patentes
Vue.component('patent-agreement', () => import('./components/patent/agreement'));
Vue.component('patent-payment', () => import('./components/patent/payment'));
Vue.component('patent-list', () => import('./components/patent/list'));
Vue.component('patent-element', () => import('./components/patent/element'));
Vue.component('patent-search', () => import('./components/patent/search'));
Vue.component('patent-payment-list', () => import('./components/patent/payment-list'));
Vue.component('patent-value', () => import('./components/patent/value'));
Vue.component('patent-description', () => import('./components/patent/description'));

Vue.component('backend-patent-search', () => import('./components/backend/patent/search'));
Vue.component('citizen-info', () => import('./components/citizen/info'));

Vue.component('vehicle-info', () => import('./components/vehicle/info'));

// Claveunica
Vue.component('claveunica-card', () => import('./components/claveunica/card'));

Vue.component('backend-request-actions', () => import('./components/backend/requests/action'));

Vue.component('request-create', () => import('./components/request/create'));

Vue.component('request-1', () => import('./components/request/templates/1'));
Vue.component('request-2', () => import('./components/request/templates/2'));
Vue.component('request-3', () => import('./components/request/templates/3'));
Vue.component('request-4', () => import('./components/request/templates/4'));
Vue.component('request-6', () => import('./components/request/templates/6'));
Vue.component('request-7', () => import('./components/request/templates/7'));
Vue.component('request-8', () => import('./components/request/templates/8'));
Vue.component('request-9', () => import('./components/request/templates/9'));
Vue.component('request-default', () => import('./components/request/templates/default'));

Vue.component('request-search', () => import('./components/request/search'));
Vue.component('request-show', () => import('./components/request/show'));

Vue.component('request-status-badge', () => import('./components/request/statusBadge'));

Vue.component('request-user', () => import('./components/request/user'));
Vue.component('request-square-category', () => import('./components/request/square/category'));
Vue.component('request-square-request', () => import('./components/request/square/request'));

Vue.component('grooming-right-search', () => import('./components/grooming-right/search'));

Vue.component('payment-search', () => import('./components/payment/search'));
Vue.component('payment-not-found', () => import('./components/payment/not-found'));

Vue.component('payment-patent-payment', () => import('./components/payment/template/patent_payment'));
Vue.component('payment-request', () => import('./components/payment/template/request'));
Vue.component('payment-grooming-right', () => import('./components/payment/template/grooming_right'));
Vue.component('payment-penalty-fee', () => import('./components/payment/template/penalty_fee'));

Vue.component('survey-create', () => import('./components/survey/create'));

Vue.component('drugstore-search', () => import('./components/drugstore/search'));

Vue.component('backend-drugstore-upload', () => import('./components/backend/drugstore/upload'));

Vue.component('refund-create', () => import('./components/refund/create'));

Vue.component('backend-circulation-permit-index', () => import('./components/backend/circulationPermit/Index'));
Vue.component('circulation-permit-create', () => import('./components/circulationPermit/Create'));

Vue.component('reservation-dom-create', () => import('./components/reservation/dom/Create'));

Vue.component('chilegob-card', () => import('./components/chileGob/Card'));

Vue.component('backend-scholarship-index', () => import('./components/backend/scholarship/Index'));
Vue.component('backend-scholarship-admin', () => import('./components/backend/scholarship/Admin'));
Vue.component('backend-scholarship-type', () => import('./components/backend/scholarship/Type'));
Vue.component('backend-scholarship-inscription-index', () => import('./components/backend/scholarship/inscription/index/Index'));
Vue.component('backend-scholarship-inscription-show', () => import('./components/backend/scholarship/inscription/show/Show'));
// Vue.component('backend-scholarship-type-card', () => import('./components/backend/scholarship/TypeCard'));

Vue.component('scholarship-index', () => import('./components/scholarship/Index'));
Vue.component('scholarship-create', () => import('./components/scholarship/Create'));

Vue.component('covid-social-help', () => import('./components/covid/SocialHelp'));

Vue.component('payment-index', () => import('./components/payment/Index'));

Vue.component('inscription-create', () => import('./components/inscriptions/Create'));

Vue.component('social-help-form-create', () => import('./components/socialHelpForm/Create'));

Vue.component(
    'backend-grooming-right-create-mass-update-as-paid',
    () => import('./components/backend/groomingRight/createMassUpdateAsPaid/Index')
);

Vue.component(
    'backend-grooming-right-create-mass-upload',
    () => import('./components/backend/groomingRight/createMassUpload/Index')
);

Vue.component(
    'backend-grooming-right-create-mass-upload-discount',
    () => import('./components/backend/groomingRight/createMassUploadDiscount/Index')
);

// Vue.component('file-card', () => import('./components/FileCard'));
// Vue.component('html-container', () => import('./components/HtmlContainer'));

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import vSelect from "vue-select";

Vue.component('vue-select', vSelect);
Vue.component('vue-select-css', require('vue-select/dist/vue-select.css'));

import * as GmapVue from 'gmap-vue';

Vue.use(GmapVue, {
    load: {
        key: 'AIzaSyAhAetxAFjbVNeiY2cOPoZaNQ5me3GP8G8',
        libraries: 'places, geometry, autocomplete',
        installComponents: true
    },
});

import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg, {
    hideModules: {
        "image": true,
        "justifyLeft": true,
        "justifyCenter": true,
        "justifyRight": true,
        "code": true,
        "table": true,
        "separator": true,
    },
    forcePlainTextOnPaste: true,
}); // config is optional. more below


// DECLARACION PARA VARIABLES GLOBALES

// import Vuelidate from 'vuelidate';
// Vue.use(Vuelidate);
//
// import Vuex from 'vuex';
//
// const store = new Vuex.Store({
//     mutations: {
//         test(){
//             console.log('XD');
//         },
//     }
// });

// Vue.use(Vuex);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});


